import React from "react";

function GoldGradients() {
  return (
    <defs>
      <linearGradient id="ezA" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#FBE68F" />
        <stop offset="0.5" stopColor="#E2B33C" />
        <stop offset="1" stopColor="#9E6C0C" />
      </linearGradient>
      <linearGradient id="ezBar" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="#B98216" />
        <stop offset="0.45" stopColor="#F7DE84" />
        <stop offset="1" stopColor="#A9770F" />
      </linearGradient>
      <linearGradient id="ezRing" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="#F6DA78" />
        <stop offset="0.5" stopColor="#C8941A" />
        <stop offset="1" stopColor="#8A5E09" />
      </linearGradient>
    </defs>
  );
}

// Scalable vector recreation of the eziwebb emblem (gold pillars + orbit ring).
export default function EziMark({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 240 240" className={className} xmlns="http://www.w3.org/2000/svg">
      <GoldGradients />

      <g transform="rotate(-28 120 120)">
        <path d="M 24 120 A 96 38 0 0 1 216 120" fill="none" stroke="url(#ezRing)" strokeWidth="15" strokeLinecap="round" />
      </g>

      <g stroke="#7d560a" strokeWidth="1.5" strokeLinejoin="round">
        <polygon points="98,72 178,52 188,66 108,86" fill="url(#ezBar)" />
        <polygon points="96,180 112,180 126,68 110,68" fill="url(#ezBar)" />
        <polygon points="120,180 136,180 150,68 134,68" fill="url(#ezBar)" />
        <polygon points="144,180 160,180 174,68 158,68" fill="url(#ezBar)" />
        <polygon points="88,178 172,178 184,196 100,196" fill="url(#ezBar)" />
      </g>

      <g transform="rotate(-28 120 120)">
        <path d="M 216 120 A 96 38 0 0 1 24 120" fill="none" stroke="url(#ezA)" strokeWidth="15" strokeLinecap="round" />
      </g>
    </svg>
  );
}
